export const TIPO_IMPUESTOS_MODELOS_ENUM = {
  IMPUESTO_SOPORTADO: 0,
  IMPUESTO_REPERCUTIDO: 1,
} as const

export type TipoImpuestoModeloType =
  (typeof TIPO_IMPUESTOS_MODELOS_ENUM)[keyof typeof TIPO_IMPUESTOS_MODELOS_ENUM]
